export default "__VITE_ASSET__CxV04k_m__"